import React, { useState, useImperativeHandle, forwardRef, useRef } from 'react'
import Api from '@/_helpers/Api'
import { trans } from '@/_providers/Translation'
import Success from '@/components/modals/messages/Success'
import Error from '@/components/modals/messages/Error'
import Ckeditor from '@/components/partials/Ckeditor'
import { ENDPOINTS } from './config'

//images
import popupDefaultHeadImage from '@/assets/img/modals/icons/head.svg'
import loader from '@/assets/img/loader.svg'

const emptyData = {
    email: '',
    subject: '',
    message: '',
}

function SendEmail(props, ref) {

    const contractType = props.typeId

    const successModalRef = useRef(null)
    const errorModalRef = useRef(null)

    const [popup, setPopup] = useState({
        overlay: false,
        modal: false,
        loading: false,
        id: null,
        contract: null,
        // Прозорецът стои постоянно в дървото, затова полетата се държат от
        // състоянието. С defaultValue въведеното веднъж оставаше в DOM и
        // следващият договор се отваряше с данните на предишния.
        data: { ...emptyData },
        // Брояч на отварянията - нулира редактора при всяко ново отваряне.
        nonce: 0,
    })

    const [validations, setValidations] = useState(null)

    useImperativeHandle(ref, () => ({
        open: (id, contract) => {
            handleShow(id, contract)
        },
        hide: () => {
            handleHide()
        }
    }))

    const handleShow = (id, contract) => {
        setPopup(prev => ({
            ...prev,
            overlay: true,
            loading: false,
            id: id,
            contract: contract || null,
            // Всяко отваряне зарежда наново данните на избрания договор.
            data: {
                ...emptyData,
                email: contract?.contractor?.email || '',
                subject: contract?.title || '',
            },
            nonce: prev.nonce + 1,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: true,
                modal: true
            }))
        }, 50)
    }

    const handleHide = e => {
        if (e) {
            e.preventDefault()
        }

        setPopup(prev => ({
            ...prev,
            modal: false,
            loading: false,
        }))

        setTimeout(() => {
            setPopup(prev => ({
                ...prev,
                overlay: false,
                modal: false,
                id: null,
                contract: null,
                data: { ...emptyData },
            }))
        }, 50)

        setValidations(null)
    }

    const handleInputChange = e => {
        const { name, value } = e.target

        setPopup(prev => ({
            ...prev,
            data: {
                ...prev.data,
                [name]: value
            }
        }))
    }

    const handleSend = e => {
        e.preventDefault()

        setPopup(prev => ({
            ...prev,
            loading: true,
        }))

        setValidations(null)

        let data = new FormData(e.target)

        data.append('id', popup.id)
        data.append('contract_type', contractType)

        Api.post(ENDPOINTS.send, data)
            .then(res => {

                handleHide()

                if (res.data.success === false) {
                    errorModalRef.current.open()
                } else {
                    successModalRef.current.open()

                    if (typeof props.handleSent === 'function') {
                        props.handleSent(res.data)
                    }
                }

            }).catch(error => {

                setPopup(prev => ({
                    ...prev,
                    loading: false,
                }))

                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {

                        setValidations(prevState => {
                            return { ...prevState, [input]: true }
                        })
                    }
                } else {
                    errorModalRef.current.open()
                }

            })
    }

    return (
        <>
            <Success
                ref={successModalRef}
                mainMessage={trans('headings.success6')}
            />

            <Error
                ref={errorModalRef}
                mainMessage={trans('headings.error3')}
            />

            <div className={`${popup.overlay ? 'visible' : ''} overlay`}>
                <form className={`${popup.modal ? 'show' : ''} popup-primary medium contracts-modal`} onSubmit={handleSend}>
                    <div className="head-new">
                        <img src={popupDefaultHeadImage} alt="icon" />
                        <div className="texts">
                            <h2>
                                {trans('headings.sendContract')}
                            </h2>
                            <p>{trans('subheadings.sendContract')}</p>
                        </div>
                        <span className="close" onClick={handleHide}>

                        </span>
                    </div>

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                {trans('labels.recipient')}
                            </label>
                            <input
                                type="text"
                                name="email"
                                value={popup.data.email}
                                onChange={handleInputChange}
                                className={validations && validations.email ? 'validate' : ''}
                            />
                        </div>
                    </div>

                    <br />

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                {trans('labels.subject')}
                            </label>
                            <input
                                type="text"
                                name="subject"
                                value={popup.data.subject}
                                onChange={handleInputChange}
                                className={validations && validations.subject ? 'validate' : ''}
                            />
                        </div>
                    </div>

                    <br />

                    <div className="popup-container">
                        <div className="col">
                            <label>
                                {trans('labels.message')}
                            </label>
                            <div className={`contracts-editor ${validations && validations.message ? 'validate' : ''}`}>
                                {/* adkey се сменя при всяко отваряне - иначе редакторът
                                    задържа текста от предишния договор. */}
                                <Ckeditor
                                    adkey={`contract-message-${popup.nonce}`}
                                    name="message"
                                    value={popup.data.message}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="footer align-right">
                        {popup.loading ?
                            <img src={loader} alt="loading" />
                            :
                            <>
                                <button className="button" onClick={handleHide}>
                                    {trans('buttons.cancel')}
                                </button>
                                <button className="button button-primary" type="submit">
                                    {trans('buttons.send')}
                                </button>
                            </>
                        }
                    </div>
                </form>
            </div>
        </>
    )
}

export default forwardRef(SendEmail)
